import React, { useEffect } from 'react';
import { Button, Form } from 'antd';
import Drawer from '../../../components/AppDrawer';
import ContactForm, { type ContactFormFieldValues } from './ContactForm';
import type { ContactDetail, ContactFormValues } from '../types';

export interface ContactFormDrawerProps {
  open: boolean;
  onClose: () => void;
  mode: 'add' | 'edit';
  contactId: string | null;
  contact: ContactDetail | null | undefined;
  loadingContact: boolean;
  ownerOptions: { value: string; label: string }[];
  categoryOptions: { value: number; label: string }[];
  roleOptions: { value: number; label: string }[];
  loadingCategories: boolean;
  loadingRoles: boolean;
  loadingOwners: boolean;
  onSave: (values: ContactFormValues) => void;
  saving: boolean;
}

const ContactFormDrawer: React.FC<ContactFormDrawerProps> = ({
  open,
  onClose,
  mode,
  contact,
  loadingContact,
  ownerOptions,
  categoryOptions,
  roleOptions,
  loadingCategories,
  loadingRoles,
  loadingOwners,
  onSave,
  saving,
}) => {
  const [form] = Form.useForm<ContactFormFieldValues>();

  useEffect(() => {
    if (!open) return;
    if (mode === 'add') {
      form.resetFields();
      form.setFieldsValue({ contactType: 0 });
    }
  }, [open, mode, form]);

  const title = mode === 'add' ? 'Add contact' : 'Edit contact';

  return (
    <Drawer
      title={title}
      destroyOnClose
      size="large"
      placement="right"
      open={open}
      onClose={onClose}
      footer={
        <div style={{ textAlign: 'right' }}>
          <Button onClick={onClose} style={{ marginRight: 8 }}>
            Cancel
          </Button>
          <Button
            type="primary"
            loading={saving}
            disabled={loadingCategories || categoryOptions.length === 0}
            onClick={() => form.submit()}
          >
            Save
          </Button>
        </div>
      }
    >
      {(mode === 'add' || !loadingContact) && (
        <ContactForm
          form={form}
          initialValues={mode === 'edit' ? contact ?? null : null}
          ownerOptions={ownerOptions}
          categoryOptions={categoryOptions}
          roleOptions={roleOptions}
          loadingCategories={loadingCategories}
          loadingRoles={loadingRoles}
          loadingOwners={loadingOwners}
          onFinish={onSave}
        />
      )}
    </Drawer>
  );
};

export default ContactFormDrawer;
